export const m = {
    menuLists: [
        { index: 1, title: 'Home', linkHref: '#page1', childList: [] },
        {
          index: 2,
          title: 'Projects',
          linkHref: '#page2',
          childList: []
        },
        { index: 3, title: 'Freelancer', linkHref: '#page3', childList: [
          {
            childIndex: 1,
            childTitle: 'back-end developer'
          },
          {
            childIndex: 2,
            childTitle: 'front-end developer'
          },
          {
            childIndex: 3,
            childTitle: 'App developer'
          },
          {
            childIndex: 4,
            childTitle: 'DBA'
          }
        ] },
        { index: 4, title: 'Cooperation', linkHref: '#page4', childList: [] },
        { index: 5, title: '中文', linkHref: '#', childList: [] }
      ],
}